import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppShell } from "@/components/layout/AppShell";
import Expenses from "@/pages/Expenses";
import Policies from "@/pages/Policies";
import Integrations from "@/pages/Integrations";
import Communications from "@/pages/Communications";
import { EmployeeCommand } from "@/pages/EmployeeCommand";
import Settings from "@/pages/Settings";
import Portal from "@/pages/Portal";
import Onboarding from "@/pages/Onboarding";

function RedirectEmployees() {
  const location = useLocation();
  return <Navigate to={`/communications${location.search}`} replace />;
}

function EmployeeThread() {
  const { id } = useParams();
  return <EmployeeCommand id={id} />;
}

function App() {
  return (
    <TooltipProvider delayDuration={150}>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<Navigate to="/communications" replace />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/approvals" element={<Navigate to="/expenses" replace />} />
            <Route path="/archive" element={<Navigate to="/expenses?mode=archive" replace />} />
            <Route path="/aria" element={<Navigate to="/expenses" replace />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/communications" element={<Communications />} />
            <Route path="/employees" element={<RedirectEmployees />} />
            <Route path="/employees/:id" element={<EmployeeThread />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="/portal" element={<Portal />} />
          <Route path="/onboarding" element={<Onboarding />} />
        </Routes>
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </TooltipProvider>
  );
}

export default App;
